import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
} from "@mui/material";
import Title from "../../ui/Title";
import { Card, DatePickerEl } from "../../ui/uiImport";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import { FetchMISReports, FetchReports } from "../../../config/api";
import { exportToExcel } from "../../../utils/downloadExcel";
import { StyledButton } from "../../ui/StyledButton";
import { log } from "console";
import CustomDataTable from "../../ui/CustomDataTableThree";

const MISReportsColumn = [
  // {
  //   field: "Shipement ID",
  //   headerName: "Shipment ID",
  //   minWidth: 140,
  //   flex: 1,
  // },
  {
    field: "Shipment Status",
    headerName: "Shipment Status",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "Quantity",
    headerName: "Quantity",
    minWidth: 140,
    flex: 1,
  },
  // {
  //   field: "Product type",
  //   headerName: "Product type",
  //   minWidth: 140,
  //   flex: 1,
  // },
  {
    field: "Customer name",
    headerName: "Customer Name",
    minWidth: 140,
    flex: 1,
  },
  // {
  //   field: "Customer mobile",
  //   headerName: "Customer mobile",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "Customer Address",
  //   headerName: "Customer Address",
  //   minWidth: 200,
  //   flex: 1,
  // },
  {
    field: "Payment type",
    headerName: "Payment Type",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "Booked Weight",
    headerName: "Booked Weight",
    minWidth: 160,
    flex: 1,
  },
  {
    field: "AWB Number",
    headerName: "AWB Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "Service",
    headerName: "Service",
    minWidth: 140,
    flex: 1,
  },
  // {
  //   field: "Ewaybill number",
  //   headerName: "Ewaybill number",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "Track time",
  //   headerName: "Track time",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "Pickup time",
  //   headerName: "Pickup time",
  //   minWidth: 140,
  //   flex: 1,
  // },
  {
    field: "Invoice value",
    headerName: "Invoice Value",
    minWidth: 140,
    flex: 1,
  },
  // {
  //   field: "Invoice number",
  //   headerName: "Invoice number",
  //   minWidth: 150,
  //   flex: 1,
  // },
  // {
  //   field: "Invoice created",
  //   headerName: "Invoice created",
  //   minWidth: 150,
  //   flex: 1,
  // },
  // {
  //   field: "COD Charges",
  //   headerName: "COD Charges",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "COD Amount",
  //   headerName: "COD Amount",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "Fright Charges",
  //   headerName: "Freight Charges",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "Measured Weight",
  //   headerName: "Measured Weight",
  //   minWidth: 160,
  //   flex: 1,
  // },
  // {
  //   field: "Extra Weight Charge",
  //   headerName: "Extra Weight Charge",
  //   minWidth: 140,
  //   flex: 1,
  // },
  // {
  //   field: "Total Fright Charges",
  //   headerName: "Total Freight Charges",
  //   minWidth: 180,
  //   flex: 1,
  // },
  // {
  //   field: "Created",
  //   headerName: "Created",
  //   minWidth: 200,
  //   flex: 1,
  // },
];

const allColumns = [
  { field: "order_id", headerName: "Order ID", minWidth: 140, flex: 1 },
  { field: "Shipment Status", headerName: "Shipment Status", minWidth: 140, flex: 1 },
  { field: "Item Description", headerName: "Item Description", minWidth: 160, flex: 1 },
  { field: "Number of Box", headerName: "Number of Box", minWidth: 140, flex: 1 },
  { field: "Customer Name", headerName: "Customer Name", minWidth: 140, flex: 1 },
  { field: "AWB Number", headerName: "AWB Number", minWidth: 140, flex: 1 },
  { field: "Booking Date", headerName: "Booking Date", minWidth: 140, flex: 1 },
  { field: "Pickup Date", headerName: "Pickup Date", minWidth: 140, flex: 1 },
  { field: "Delivery Date", headerName: "Delivery Date", minWidth: 140, flex: 1 },
  { field: "Invoice Value", headerName: "Invoice Value", minWidth: 140, flex: 1 },
  { field: "Invoice Number", headerName: "Invoice Number", minWidth: 160, flex: 1 },
  { field: "Origin City", headerName: "Origin City", minWidth: 140, flex: 1 },
  { field: "Delivery Date", headerName: "Destination City", minWidth: 140, flex: 1 },
  { field: "LR Number", headerName: "LR Number", minWidth: 140, flex: 1 },
  { field: "Expected Delivery", headerName: "Expected Delivery", minWidth: 160, flex: 1 },
  { field: "Age (Days)", headerName: "Age (Days)", minWidth: 120, flex: 1 },
  { field: "RTO Delivery Date", headerName: "RTO Delivery Date", minWidth: 160, flex: 1 },
  { field: "Attempt Count", headerName: "Attempt Count", minWidth: 140, flex: 1 },
  { field: "Final Attempt Datetime", headerName: "Final Attempt Datetime", minWidth: 180, flex: 1 },
  { field: "Final Attempt Reason", headerName: "Final Attempt Reason", minWidth: 180, flex: 1 },
  { field: "RTO Adress", headerName: "RTO Address", minWidth: 160, flex: 1 },
];





const reportFilter = [
  {
    label: "All",
    index: 0,
    search: "",
  },
  {
    label: "Delivered",
    index: 1,
    search: "delivered",
  },
  {
    label: "Booked",
    index: 2,
    search: "booked",
  },
  {
    label: "Intransit",
    index: 3,
    search: "intransit",
  },
  {
    label: "Exception",
    index: 4,
    search: "exception",
  },
  {
    label: "RTO",
    index: 5,
    search: "rto",
  },
  {
    label: "Return",
    index: 6,
    search: "return",
  },
  {
    label: "Dispute Shipments",
    index: 7,
    search: "dispute_shipments",
  },
  {
    label: "COD Shipments",
    index: 8,
    search: "cod_shipments",
  },
];

const MISReports = () => {
  // date filters
  const [searchParams, setSearchParams] = useSearchParams();
const defaultVisibleFields = [
  "orderId",
  "shipmentStatus",
  "itemDescription",
  "numberOfBox",
  "customerName",
];

  const initialVisibilityModel = allColumns.reduce((acc, col) => {
  acc[col.field] = defaultVisibleFields.includes(col.field);
  return acc;
}, {} as Record<string, boolean>);
console.log("initialVisibilityModel",initialVisibilityModel)

const [columnVisibilityModel, setColumnVisibilityModel] = useState<Record<string, boolean>>(
 {
    "Order ID": true,
    "Shipment Status": true,
    "Item Description": true,
    "Number of Box": false,
    "Customer Name": true,
    "AWB Number": false,
    "Booking Date": false,
    "Pickup Date": false,
    "Delivery Date": false,
    "Invoice Value": true,
    "Invoice Number": true,
    "Origin City": false,
    "LR Number": false,
    "Expected Delivery": false,
    "Age (Days)": false,
    "RTO Delivery Date": false,
    "Attempt Count": false,
    "Final Attempt Datetime": false,
    "Final Attempt Reason": false,
    "RTO Adress": false
}
);
console.log("columnVisibilityModel",columnVisibilityModel)


  const startDateConstant =
    (searchParams.get("start-date") && dayjs(searchParams.get("start-date"))) ||
    dayjs();
  const endDateConstant =
    (searchParams.get("end-date") && dayjs(searchParams.get("end-date"))) ||
    dayjs();
  const reportTypeConstant =
    (searchParams.get("report_type") && searchParams.get("report_type")) || "";
  const [startDate, setStartDate] = useState<Dayjs | null>(startDateConstant);
  const [endDate, setEndDate] = useState<Dayjs | null>(endDateConstant);
  const handleDateChange = (time: Dayjs | null, type: string) => {
    const date = time?.format("YYYY-MM-DD") || "";

    if (type === "start") {
      setStartDate(time);
      searchParams.set("start-date", date);
    } else {
      setEndDate(time);
      searchParams.set("end-date", date);
    }
    setSearchParams(searchParams);
  };

  const [reportType, setReportType] = useState(reportTypeConstant);

  // report types filters
  const reportParams = searchParams.get("report_type") || "";
  let indexOfReport = reportFilter.findIndex((data) => {
    return data.label === reportParams;
  });
  indexOfReport = indexOfReport === -1 ? 0 : indexOfReport;
  const [report, setReport] = useState(indexOfReport);

  const handleReportChange = (event: SelectChangeEvent) => {
    const index = parseInt(event.target.value);
    setReport(index);
    searchParams.set("report_type", reportFilter[index].search);
    setSearchParams(searchParams);
    if (index === reportFilter[index].index) {
      setReportType(reportFilter[index].search);
    }
  };

  // fetching data
  const [dataReport, setDataReport] = useState<any[]>([]);

 useEffect(() => {
    FetchMISReports(dayjs(startDate), dayjs(endDate), reportType)
      .then((data) => {
        const headers = data?.data?.data[0] as string[];
        const finalData = data?.data?.data[1] as string[][];

        const formattedData = finalData.map((row, index) => {
          const rowData: Record<string, string | number> = { id: index + 1 };
          headers.forEach((header, i) => {
            rowData[header] = row[i];
          });
          return rowData;
        });

        setDataReport(finalData.map((item,i)=>{
          return{...item, id:i+1}
        }));
      })
      .catch((err) => console.error(err));
  }, [startDate, endDate, reportType]);

  return (
    <>
      <Title title="MISReports" />
      <Card>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          flexWrap={"wrap"}
          rowGap={"20px"}
          columnGap={"20px"}
          marginBottom={"40px"}
        >
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            flexWrap={"wrap"}
            columnGap={"20px"}
            rowGap={"20px"}
          >
            <DatePickerEl
              defaultDate={startDate}
              handleChange={(time) => handleDateChange(time, "start")}
              label="From"
            />
            <DatePickerEl
              defaultDate={endDate}
              handleChange={(time) => handleDateChange(time, "end")}
              label="To"
            />

            <FormControl sx={{ minWidth: 200 }} size="small">
              <InputLabel id="demo-select-small-label">Report Types</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={report.toString()}
                label="Report Types"
                onChange={handleReportChange}
              >
                {reportFilter.map((el, index) => {
                  return (
                    <MenuItem key={index} value={index}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Stack>
        </Stack>

        <Stack
          direction={"row"}
          justifyContent={"end"}
          alignItems={"center"}
          marginBottom={"20px"}
        >
          <StyledButton
            onClick={() => exportToExcel(dataReport, "Reports")}
            variant="contained"
          >
            Download Reports
          </StyledButton>
        </Stack>

        <CustomDataTable
          wantExcel={false}
          total={dataReport?.length ?? 0}
          rows={dataReport ?? []}
          columns={allColumns}
          columnVisibilityModel={columnVisibilityModel}
          setColumnVisibilityModel={setColumnVisibilityModel}
        />
      </Card>
    </>
  );
};

export default MISReports;
